import { Component } from '@angular/core';
import { FriendInviteDialogComponent } from '@client/shared/components/friend-invite/friend-invite-dialog/friend-invite-dialog.component';
import { MatDialog } from '@angular/material/dialog';

/**
 * Component to open dialog to invite friend to TaxTank (Rewardful affiliate / Partner program)
 */
@Component({
  selector: 'app-friend-invite',
  templateUrl: './friend-invite.component.html',
  styleUrls: ['./friend-invite.component.scss'],
  standalone: false
})
export class FriendInviteComponent {
  constructor(
    private dialog: MatDialog
  ) {
  }

  openInviteFriendDialog() {
    this.dialog.open(FriendInviteDialogComponent);
  }
}
